import { Link } from 'react-router-dom';
import * as React from 'react';

import { ClickTracker } from 'bernie-analytics';

import { MessagingCardViewModel } from 'models';
import { Urls } from 'constants/urls';

import {
  UitkMessagingCard,
  UitkMessagingCardImageLayout,
  UitkMessagingCardMedia,
  UitkMessagingCardSection
} from 'uitk-react-messaging-cards';
import { classNames } from 'uitk-react-utils';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';

const LinkTracked = ClickTracker(Link);

export interface FreeCancellationProps {
  model: MessagingCardViewModel;
  classes: string;
}

export const FreeCancellation: React.FunctionComponent<FreeCancellationProps> = ({ model, classes }: FreeCancellationProps) => {
  const { titleModel, subtitleModel, actionModel } = model;
  const addFreeCancelFilterText: string = actionModel?.primary?.text;
  const href: string = actionModel?.primary?.href;
  const rfrr: string = actionModel?.primary?.rfrr;
  const freeCancellationClasses = classNames({
    ['all-t-margin-three all-l-margin-three']: !classes,
    [classes]: classes
  });

  return (
    <UitkMessagingCard imageLayout={UitkMessagingCardImageLayout.LEFT} className={freeCancellationClasses}>
      <UitkMessagingCardMedia>
        <UitkFigure ratio={UitkFigureAspectRatioType.R1_1} src={Urls.FREE_CANCELLATION_ILLUSTRATION} />
      </UitkMessagingCardMedia>
      <UitkMessagingCardSection heading={titleModel.text} headingLevel="h3">
        <p className="uitk-type-300 pwa-theme--grey-700">{subtitleModel.text}</p>
        {addFreeCancelFilterText && (
          <LinkTracked
            to={href}
            linkName="Filter by free cancellation"
            rfrr={rfrr}
            className="uitk-type-300 uitk-link all-t-padding-two"
            data-stid="add-free-cancel-filter-link"
          >
            {addFreeCancelFilterText}
          </LinkTracked>
        )}
      </UitkMessagingCardSection>
    </UitkMessagingCard>
  );
};

FreeCancellation.displayName = 'FreeCancellation';
